import React, { useEffect } from "react";
import "./description.css";
import children from "./children.png";
import { useInView } from "react-intersection-observer";
import { useState } from "react";
function Description() {
  const { ref, inView, entry } = useInView({
    onChange: (inView) => {
      if (inView) {
        animate();
      } else {
        reanimate();
      }
    },
  });
  const animate = () => {
    document.querySelector(".desc-container img").style.transform =
      "scale(1.2)";
    document.querySelector(".box").style.backgroundColor = "rgba(0, 0, 0, .7)";
    document.querySelector(".box").style.transform = "translateY(0)";
    document.querySelector(".box").style.opacity = "1";
    document.querySelector(".content").style.backgroundColor =
      "rgba(0, 0, 0, .7)";
    document.querySelector(".content").style.transform = "translateY(0)";
    document.querySelector(".content").style.opacity = "1";
    document.querySelector(".wrap").style.transform = "translateY(0)";
    document.querySelector(".wrap").style.opacity = "1";
    document.querySelector(".desc-container h1").style.transform =
      "translateY(0)";
    document.querySelector(".desc-container h1").style.opacity = "1";
    document.querySelector("#three").style.transform = "translateY(0)";
    document.querySelector("#three").style.opacity = "1";
    document.querySelector("#four").style.transform = "translateY(0)";
    document.querySelector("#four").style.opacity = "1";
  };
  const reanimate = () => {
    document.querySelector(".desc-container img").style.transform = "scale(1)";
    document.querySelector(".box").style.backgroundColor = "transparent";
    document.querySelector(".box").style.transform = "translateY(-80px)";
    document.querySelector(".box").style.opacity = "1";
    document.querySelector(".content").style.backgroundColor = "transparent";
    document.querySelector(".content").style.transform = "translateY(170px)";
    document.querySelector(".content").style.opacity = "0";
    document.querySelector(".wrap").style.transform = "translateY(170px)";
    document.querySelector(".wrap").style.opacity = "0";
    document.querySelector(".desc-container h1").style.transform =
      "translateY(-80px)";
    document.querySelector(".desc-container h1").style.opacity = "0";
    document.querySelector("#three").style.transform = "translateY(0)";
    document.querySelector("#three").style.opacity = "0";
    document.querySelector("#four").style.transform = "translateY(0)";
    document.querySelector("#four").style.opacity = "0";
  };
  return (
    <>
      <div class="desc-container" ref={ref}>
        {/* <h2 style={{color:"white"}}>{`Header inside viewport ${inView}.`}</h2> */}
        <div class="box">
          <img src={children} />
          <div class="content">
            <div class="wrap">
              <h1 id="one">About</h1>
              <hr id="three" />
              <p id="four">
                Good nutrition is the bedrock of child survival and development.
                Well-nourished children are better able to grow, learn, play and
                participate in their communities. They are also more resilient
                in the face of crisis.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* <hr className='hr-tag'/> */}
    </>
  );
}

export default Description;
